



































import { Vue, Component } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import Menu from '../components/Menu.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
@Component({
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },
    },
    components: {
        Menu,
    },
    data() {
        return {
            header: 'API Integration',
            options: [
                {
                    url: 'api-integration/access-keys',
                    activeConditions: {
                        lastletters: 'access-keys',
                    },
                    label: 'Access Key',
                },
            ],
        };
    },
})
export default class ApiKeys extends Vue {
    private apiIntegrationEnabled = false;
    private showEnableApiConfirmation = false;

    public async mounted() {
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization.data && organization.data.apiIntegrationEnabled) {
            this.apiIntegrationEnabled = true;
        }
        if (this.$route.path.endsWith(MedTransGoConstants.URL_API_INTEGRATION) && this.apiIntegrationEnabled) {
            this.$router.push({ path: MedTransGoConstants.URL_ACCESS_KEY_LIST, append: true });
            return;
        }
    }

    private async callEnableAPI() {
        this.showEnableApiConfirmation = false;
        const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (memberProfile.organization) {
            const response = await ObjectFactory.getOrganizationService().updateOrganization
                (this.$store.state.serverUrl, memberProfile.organization.id, {
                    apiIntegrationEnabled: true,
                });
            if (response.success) {
                const toastEvent: ToastEvent = {
                    message: 'API Integration is enabled',
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.apiIntegrationEnabled = true;
                this.$router.push({
                    path: `/${MedTransGoConstants.URL_API_INTEGRATION}/${MedTransGoConstants.URL_ACCESS_KEY_LIST}`,
                    append: true,
                });
            }
        }
    }
}
